<template>
  <div>
    <div
      class="mb-[8px] text-[#333333] flex items-center justify-start gap-[8px] [&_p]:mb-0"
    >
      <p>Revenue dari Biaya Low Moving Stock</p>
      <p>:
        <b-spinner
          v-if="summary.is_loading"
          small
          variant="primary"
          class="mb-[2px]"
        />
        <span v-else>{{ summary.revenue | rupiah }}</span></p>
    </div>
    <div class="relative">
      <b-table
        :items="dataFetcher.data"
        :fields="fieldsLowMovingStockTable"
        :busy="dataFetcher.isLoading"
        show-empty
        :empty-text="dataFetcher.isLoading ? '' : 'Tidak ada data yang ditampilkan.'"
        responsive
        class="!max-h-[50vh] !mb-0"
        :sticky-header="true"
        @scroll.native="handleScroll"
      >
        <template #cell(no)="data">
          {{ data.index + 1 }}
        </template>
        <template #cell(status)="data">
          <span
            :class="statusPillConfig[data.item.status || 'PAID'].class"
            class="text-[12px] font-normal rounded-[4px] px-[8px] py-[2px] rounded-full"
          >
            {{ statusPillConfig[data.item.status || 'PAID'].text }}
          </span>
        </template>
        <template #cell(ref_id)="data">
          <DownloadInvoice
            :no-invoice="data.value"
            :partner-name="data.item.partner_name"
            :period="data.item.period"
            status="PAID"
            :add-to-queue="queue.addToQueue"
          />
        </template>
        <template #cell(bill_type)>
          Low Moving Stock
        </template>
      </b-table>

      <div
        v-if="dataFetcher.isLoading"
        class="absolute bottom-0 left-0 right-0 flex justify-center items-center p-[20px] bg-white bg-opacity-90"
      >
        <div class="flex items-center gap-2">
          <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600" />
          <span class="text-sm text-gray-600">Memuat data...</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DAY_MONTH_YEAR, YEAR_MONTH_DAY } from '@/libs/filterDate'
import { IDR } from '@/libs/currency'
import { createPaginatedFetcher } from '@/@core/libs/fetch/usePaginatedFetcher'
import useQueueProcess from '@/@core/libs/queue/useQueueProcess'
import DownloadInvoice from '../../tagihan/components/DownloadInvoice.vue'
import {
  statusPillConfig,
} from '../../tagihan/config'
import { fieldsLowMovingStockTable } from '../config'

/**
 * Component untuk menampilkan data low moving stock
 * @component LowMovingStockCard
 */
export default {
  components: {
    DownloadInvoice,
  },
  props: {
    /** @type {Object} Periode tanggal untuk filter data */
    period: {
      type: Object,
      required: true,
    },
    /** @type {Object} Summary object containing revenue data and loading state */
    summary: {
      type: Object,
      default: () => ({ revenue: 0, is_loading: true }),
    },
  },
  data() {
    return {
      dataFetcher: createPaginatedFetcher(this.fnFetchData),
      queue: useQueueProcess(),
      statusPillConfig,
    }
  },
  watch: {
    period(value) {
      this.dataFetcher.fetchData({
        options: {
          start_date: YEAR_MONTH_DAY(value.startDate),
          end_date: YEAR_MONTH_DAY(value.endDate),
        },
        reset: true,
      })
    },
  },
  created() {
    this.fieldsLowMovingStockTable = fieldsLowMovingStockTable
  },
  mounted() {
    this.handleRefreshData()
  },
  methods: {
    /**
     * Handle refresh data
     */
    async handleRefreshData() {
      await this.dataFetcher.fetchData({
        options: {
          start_date: YEAR_MONTH_DAY(this.period.startDate),
          end_date: YEAR_MONTH_DAY(this.period.endDate),
        },
        reset: true,
      })
    },
    DAY_MONTH_YEAR,
    IDR,
    /**
     * Handle scroll untuk infinite loading
     * @param {Event} event - Event scroll
     */
    handleScroll(event) {
      if (event.target.scrollTop + event.target.clientHeight + 500 >= event.target.scrollHeight) {
        if (this.dataFetcher.data.length <= 0) return
        this.dataFetcher.fetchData()
      }
    },
    fnFetchData({
      limit, offset, start_date, end_date,
    }) {
      return this.$http_new.get('/komship/api/v1/admin/transactions/kompack/low-moving-stock', {
        params: {
          limit,
          offset,
          start_date,
          end_date,
          status: 'PAID',
        },
      }).then(res => {
        const { data } = res.data
        return {
          data,
        }
      }).catch(() => ({
        data: [],
      }))
    },
  },
}
</script>
